import { Enumerate } from '@internal/plugin-components-react/src/utils/enum';

export const FlaggedFeature = Enumerate([
  'backstage-catalog',
  'backstage-cluster-management',
  'announcement',
]);
